export default "__VITE_ASSET__BGyAQZsZ__"